import axios from "axios";
import API_RESOURCES from "constants/service-resources";
import IVisitador from "interfaces/service/models/IVisitador";

export async function visitadores() {
    const result = await axios.get<IVisitador[]>(API_RESOURCES.OPCIONES.BASE + '/visitadores')
    return result.data
}